export default __webpack_public_path__ + "static/media/Group9266.d9f0d7a8.svg";